import api from "../api";
import { DEFAULT_LANGUAGE } from "../constants/languages";
import { getLanguage } from "../utils/languageUtils";

const language = getLanguage();

export const getTagTitle = (tag: api.Label, forceLanguage?: api.LanguageEnum) =>
  tag.title[forceLanguage || language] || tag.title[DEFAULT_LANGUAGE];
